export default __webpack_public_path__ + "7ce71612e4bf47639c3371d64807a5cb.png";